//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('factoryMenu', {
//        templateUrl: 'views/components/views/factoryMenu/factoryMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'factoryMenuService', function ($stateParams, factoryMenuService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let factoryId = $stateParams.factory_id;

//            vm.model = {
//                menu: {}
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await factoryMenuService.getMenu({ factory_id: factoryId }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
